import { render, staticRenderFns } from "./Table-info.vue?vue&type=template&id=f0f20726"
import script from "./Table-info.vue?vue&type=script&lang=js"
export * from "./Table-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports